import React, { Component } from 'react';
import { SubmissionError } from 'redux-form';

import MassChargeForm from 'components/MassActions/Purchases/MassChargeForm';
import { massPurchaseCharge } from 'api';
import Spinner from 'components/Spinner';
import { toast } from 'react-toastify';

class MassCharge extends Component {
  state = {
    result: null,
    loading: false,
  };

  transformValues = (values) => {
    let newValues = { ...values };
    ['purchase_ids', 'emails'].forEach((field) => {
      newValues[field] = values[field].replace(/ /g, '').split(',');
    });
    return newValues;
  };

  handleSubmit = (values) => {
    this.setState({ loading: true });
    return massPurchaseCharge(this.transformValues(values))
      .then((res) => {
        this.setState({ loading: false, result: res.data });
        toast.success('Requested mass charge successfully');
      })
      .catch((err) => {
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        if (typeof messages === 'object' && !Array.isArray(messages)) {
          const messagesKeys = Object.keys(messages);
          messagesKeys.forEach((messagesKey) => {
            if (
              typeof messages?.[messagesKey] === 'object' &&
              !Array.isArray(messages?.[messagesKey])
            ) {
              const keys = Object.keys(messages[messagesKey]);
              const numericKeys = keys.filter((key) => Number(key));
              if (numericKeys.length) {
                const numericKeysValues = numericKeys.map(
                  (key) => `${key}: ${messages[messagesKey][key]}`,
                );
                messages[messagesKey] = numericKeysValues.join('; ');
              }
            }
          });
        }
        this.setState({ loading: false, result: null });
        throw new SubmissionError(messages);
      });
  };

  render() {
    const { loading } = this.state;
    const initialValues = {
      purchase_ids: '',
      emails: '',
      only_with_autopay: false,
      enable_autopay: false,
      only_overdue: false,
      run_all_cards_on_file: false,
    };

    return (
      <div>
        <h2>Mass Charge</h2>
        <div className="relative">
          <MassChargeForm
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
          />
          <Spinner showLoader={loading} />
        </div>
      </div>
    );
  }
}

export default MassCharge;
